import React from 'react';
import { makeStyles, TextField, FormControl } from '@material-ui/core';
import { t } from 'src/shared/literals';

const useStyles = makeStyles((theme) => ({
  hidden: {
    display: 'none'
  },
  textField: {
    display: 'inline-flex'
  },
  formControl: {
    width: '200px',
    margin: theme.spacing(1)
  },
  formControlFullWidth: {
    width: '99%',
    margin: theme.spacing(1)
  }
}));

const FormTextField = ({ field, handleChangeField }) => {
  const classes = useStyles();

  const {
    name,
    value,
    errorMessage,
    readonly,
    hidden,
    literal,
    fullWidth
  } = field;

  const handleChange = (e) => {
    e.target.value = e.target.value.toUpperCase();
    handleChangeField(e);
  };

  return (
    <FormControl
      className={
        typeof fullWidth !== 'undefined' && fullWidth
          ? classes.formControlFullWidth
          : classes.formControl
      }
      key={name}
    >
      <TextField
        autoComplete="off"
        error={Boolean(errorMessage)}
        helperText={t(errorMessage)}
        label={t(literal ? literal.toString() : name.toString())}
        margin="normal"
        name={name}
        onBlur={() => {}}
        InputProps={{
          readOnly: readonly,
          autoComplete: 'off'
        }}
        onChange={handleChange}
        type="text"
        value={value}
        variant="outlined"
        className={hidden ? classes.hidden : classes.textField}
      />
    </FormControl>
  );
};

export default FormTextField;
